"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("./utils");
var plural = _utils.plural_fr;
var url = {
  register: '/?register',
  help: '/aide',
  contact: '/contact'
};
var _default = {
  _code: 'fr',
  path: '',
  url: url,
  male: 'Homme',
  female: 'Femme',
  couple: 'Couple',
  transvestite: 'Travesti',
  gender_to_str: function gender_to_str(gender) {
    switch (parseInt(gender)) {
      case 1:
        return this.male;
      case 2:
        return this.female;
      case 3:
        return this.couple;
      case 4:
        return this.transvestite;
      default:
        return '';
    }
  },
  photo_deleted: 'photo supprimée',
  help: 'Aide',
  creator_: 'Créateur :',
  colon: ' : ',
  rooms: 'Salles',
  main_room: 'Salle principale',
  minimize_pm: 'Réduire',
  private_messages: 'Messages Privés',
  active_contacts: 'En cours',
  all_contacts: 'Tous',
  functions_xxl_header: '',
  functions_xxl_text: '<h2>Accédez aux fonctions XXL</h2>' + '   <p>Période unique, sans renouvellement automatique, accès immédiat!</p>' + '<ul>' + '<li>Affichage de toutes les webcams en illimités</li>' + '<li>Affichage en plein écran des webcams</li>' + '<li>Fonction message privé (MP)</li>' + '<li>Création de salles privées</li>' + '<li>Accès aux salles pleines</li>' + '<li>Toutes les fonctions de la messagerie</li>' + '<li>Toutes les fonctions de la page profil</li>' + '<li>Lecture de tous les films amateurs</li>' + '<li>Affichage de toutes les photos</li>' + '<li>Blocage des utilisateurs indésirables</li>' + '<li>Participation à la modération collective</li>' + '</ul>' + '<p>... et plus encore.</p>' + '<a href="/bobtv-xxl" target="_blank">Devenir membre</a>',
  functions_xxl_link: 'Fonctions <span class="xxl-logo" title="XXL"/>',
  new_message: 'Nouveau message',
  new_messages: 'Nouveaux messages',
  text_editor_stub_anonymous: 'Votre temps de connexion en anonyme est de 10 minutes. <a class="anonymous-link-register">Enregistrez-vous</a> ou <a class="anonymous-link-login">connectez-vous</a> pour participer au tchat.',
  noncertified_full: 'Pour écrire sur le tchat vous devez être <a href="/bobtv-xxl" target="_blank">membre XXL</a> ou certifier votre compte <a class="link-activate-by-sms">par SMS</a>.',
  certification_disabled: 'Pour écrire sur le tchat vous devez être <a href="/bobtv-xxl" target="_blank">membre XXL</a>.',
  streaming_control_tooltip: 'Afficher ou masquer la fenêtre de votre webcam.<br/>Votre vidéo est visible par tous dans les deux cas.',
  placeholder: 'Écrire un message...',
  attachment_tooltip: 'Envoyer un fichier image au format .JPG',
  send: 'Envoyer',
  token0: 'jeton',
  token: 'jeton',
  tokens: 'jetons',
  pm_tokens: 'jetons privés',
  sending_token: ' jeton offert',
  sending_tokens: ' jetons offerts',
  users: 'Membres',
  users_online: 'utilisateurs en ligne',
  watch_top: 'Ouvrir le Top',
  sort_by: 'Trier par :',
  sort_by_name: 'Ordre alphabétique',
  sort_by_gender: 'Genre',
  sort_by_watching: '"Qui me regarde?"',
  sort_by_followees: 'Mes abonnements',
  sort_by_status: 'Statut',
  watch: 'Regarder',
  private_message: 'Envoyer un MP',
  view_profile: 'Voir le profil',
  follow: 'Suivre',
  unfollow: 'Ne plus suivre',
  deleteHistory: 'Effacer le MP',
  pm_history_deleted: function pm_history_deleted(user) {
    return "L'historique a \xE9t\xE9 effac\xE9 ".concat(user ? "par ".concat(user) : "");
  },
  gift_sender_anonymous: 'Un anonyme',
  offered_virtual_gift_to: 'a offert ce cadeau virtuel à',
  give_tokens_to: function give_tokens_to(value) {
    return "a offert ".concat(value, " ").concat(value > 1 ? 'jetons' : 'jeton', " \xE0");
  },
  sent_new_wall_post: 'a posté sur',
  the_wall: 'Le Mur',
  donate_info_title: "Record de jetons offerts",
  donate_info_pm: "Les jetons offerts en privé ne sont pas notifiés sur le tchat général.",
  donate_info_body: function donate_info_body(sender, receiver, amount) {
    return "<a href=\"/profil/".concat(sender, "\" target=\"_blank\">@").concat(sender, "</a> a offert ").concat(amount, " jetons \xE0 <a href=\"/profil/").concat(receiver, "\" target=\"_blank\">@").concat(receiver, "</a> le ");
  },
  failed_streaming: 'Échec de la connexion vidéo.<br/>Vérifiez les paramètres de votre navigateur ou de votre webcam.',
  opening_video: 'Connexion en cours...',
  message_me_blocked: function message_me_blocked(user) {
    return 'Désolé, vous êtes bloqué <span class="type h24">24 heures</span><span class="type permanent">définitivement</span> par&nbsp;<span class="nick">' + (0, _utils.escape)(user.nick) + '</span>.<br/>Vous ne pouvez plus le ou la lire, regarder sa vidéo et lui envoyer de message.';
  },
  message_video_paused: 'Pause',
  message_user_blocked: function message_user_blocked(user) {
    return 'Vous avez bloqué <span class="nick">' + (0, _utils.escape)(user.nick) + '</span>, vous ne pouvez pas lui envoyer de message privé.';
  },
  message_user_offline: 'Coupure du flux vidéo ...',
  message_limit_reached: 'Désolé, votre temps de visionnage gratuit est expiré.<br/>Devenez <a href="/bobtv-xxl" target="_blank">membre XXL</a> pour afficher plusieurs webcams en illimité.',
  message_please_register: 'Enregistrez-vous pour retirer le floutage.',
  block: 'Bloquer',
  block_confirm: function block_confirm(user) {
    return '<strong>Voulez-vous bloquer <span class="nick">' + (0, _utils.escape)(user.nick) + '</span>?</strong><br/><br/><em><span class="nick">' + (0, _utils.escape)(user.nick) + '</span> ne <nobr>pourra plus vous lire</nobr>, <nobr>regarder votre vidéo</nobr> et <nobr>vous envoyer de messages.</nobr><br/>Ne bloquez pas sans raison!</em>';
  },
  block_placeholder: 'Raison du blocage',
  block_24h: '24 heures',
  block_permanent: 'définitivement',
  block_no: 'non',
  unblock: 'Débloquer',
  unblock_confirm: function unblock_confirm(user) {
    return 'Voulez-vous débloquer <span class="nick">' + (0, _utils.escape)(user.nick) + '</span>?';
  },
  mute_one_hour: 'Cliquer pour censurer une heure',
  unmute_one_hour: 'Cliquer pour décensurer',
  fullscreen_confirm: 'Basculez en mode plein écran pour un meilleur affichage.',
  fullscreen_yes: 'Plein écran',
  fullscreen_forget: 'Ne plus demander',
  exclude: 'Exclure du tchat',
  ban: 'Ban',
  give_virtual_gift: 'Offrir un cadeau virtuel',
  give_xxl: 'Offrir un XXL',
  revoke_pm: "Révoquer le MP",
  close_pm: 'Fermer le MP',
  pm_not_allowed_text: function pm_not_allowed_text(user) {
    return "Voulez-vous demander un MP <br>\xE0 ".concat((0, _utils.escape)(user.nick), "?");
  },
  yes: 'Oui',
  no: 'Non',
  pm_pending_text: function pm_pending_text(user) {
    return 'Votre demande de MP à ' + (0, _utils.escape)(user.nick) + ' est en attente.<br/> Son accord est nécessaire pour débuter une conversation.';
  },
  pm_pending_text_payment: "Les membres Premium peuvent débuter une conversation sans attendre l'accord du destinataire.",
  pm_request_cancel: 'Annuler',
  pm_request_premium: 'Devenez membre Premium',
  pm_requested_text: function pm_requested_text(user) {
    return (0, _utils.escape)(user.nick) + ' vous demande un MP.<br/>Acceptez-vous?';
  },
  agree: 'Accepter',
  refuse: 'Refuser',
  pm_rejected_text: function pm_rejected_text(user) {
    return 'Désolé, ' + (0, _utils.escape)(user.nick) + ' a refusé votre demande de MP.';
  },
  pm_revoked_text: 'Votre MP n’est plus autorisé.',
  pm_revoked_by_me_text: 'You revoked PM permission. Do you want to allow PM again?',
  pm_revoked_or_denied_by_me_text: function pm_revoked_or_denied_by_me_text(user) {
    return 'Vous aviez refusé le PM de ' + (0, _utils.escape)(user.nick) + '. Voulez-vous l\'accepter maintenant?';
  },
  pm_user_connected: function pm_user_connected(user, chatrooms) {
    var nick = (0, _utils.escape)(user.nick);
    var chatrooms_str = "";
    if (chatrooms) {
      chatrooms_str = " sur " + user.chatrooms.join(", ");
    }
    if (user.gender == 1) return nick + " est connecté" + chatrooms_str + ".";
    if (user.gender == 2) return nick + " est connectée" + chatrooms_str + ".";
    if (user.gender == 3) return nick + " est connecté" + chatrooms_str + ".";
    return nick + " est connecté" + chatrooms_str + ".";
  },
  pm_user_disconnected: function pm_user_disconnected(user) {
    var nick = (0, _utils.escape)(user.nick);
    if (user.gender == 1) return nick + " est deconnecté.";
    if (user.gender == 2) return nick + " est deconnectée.";
    if (user.gender == 3) return nick + " est deconnecté.";
    return nick + " est deconnecté.";
  },
  user_disconnected: function user_disconnected(user) {
    if (user.gender == 2) return "deconnectée";
    return "deconnecté";
  },
  info_age: 'Âge :',
  info_years: function info_years(user) {
    return user.age ? parseInt(user.age) + (user.age > 1 ? ' ans' : ' an') : '—';
  },
  info_country: 'Pays :',
  info_region: 'Région :',
  info_gender: 'Genre :',
  info_male: 'homme',
  info_female: 'femme',
  info_couple: 'couple',
  info_trans: 'travesti',
  info_camera: 'Webcam :',
  info_watching: 'Me regarde :',
  info_certified_no: 'Censuré(e) une heure',
  info_cannot_write: 'Ne peut pas écrire',
  info_status: 'Statut :',
  info_online: 'En ligne :',
  info_yes: 'oui',
  info_no: 'non',
  info_status_anonymous: 'visiteur',
  info_status_free: 'gratuit',
  info_status_xxl: 'XXL',
  fancybox_prev: 'Précédente',
  fancybox_next: 'Suivante',
  fancybox_close: 'Fermer',
  fancybox_error: 'Le contenu demandé ne peut pas être chargé.<br/>S’il vous plaît réessayer plus tard.',
  upload_general_error: 'Erreur de téléchargement.',
  create_new_room: 'Créer une salle',
  refreshing_room_list: 'Actualisation...',
  room_name: 'Nom de la salle',
  with_password: 'Avec mot de passe',
  your_password: 'Votre mot de passe',
  create: 'créer',
  please_wait: 'Veuillez patienter...',
  create_room_error_name_empty: 'Veuillez donner un nom à la nouvelle salle.',
  create_room_error_room_exists: 'Une salle avec ce nom existe déjà.',
  create_room_error_password_empty: 'Veuillez choisir un mot de passe.',
  create_room_error_passwords_not_match: 'Les mots de passe sont différents.',
  create_room_error_xxl: 'Vous devez être <a href="/bobtv-xxl" target="_blank">membre XXL</a> pour créer une salle.',
  create_room_error_general: 'Impossible de créer une nouvelle salle, essayez plus tard.',
  entering_chat_room: 'Connexion avec la salle de tchat en cours ...',
  reconnection_message: 'La connexion avec la salle de tchat est perdue.<br/>Re-connexion en cours ...',
  disconnected_message: 'Vous avez été déconnecté.',
  reconnect: 'Se reconnecter',
  already_connected: 'Vous êtes déjà connecté sur la salle avec un premier appareil, voulez-vous connecter un second appareil ?',
  supported_browsers: 'Pour vous connecter sur ce tchat, utilisez impérativement les navigateurs <a href="https://www.google.com/chrome/index.html" target="_blank">Google Chrome</a>, <a href="https://support.apple.com/downloads/safari">Safari</a>, <a href="https://www.mozilla.org/firefox/new/" target="_blank">Mozilla Firefox</a> ou <a href="http://www.opera.com/download" target="_blank">Opéra</a>, ' + 'avec les ordinateurs Windows et MacOS X et avec les smartphones ou tablettes Androïd.<br>' + 'Seul Safari est pour le moment compatible avec les iPhone et les iPad en version iOS 12.2 et supérieures.',
  firefox_esr: "<strong>Firefox ESR</strong> n'est plus compatible avec la salle <strong>BobTV</strong>.<br/>Veuillez utiliser la dernière version de <a href=\"https://www.mozilla.org/firefox/new/\" target=\"_blank\">Firefox</a>, <a href=\"https://www.google.com/chrome/index.html\" target=\"_blank\">Google Chrome</a> ou <a href=\"http://www.opera.com/download\" target=\"_blank\">Opéra</a>.",
  become_xxl_to: 'Vous devez être <a href="/bobtv-xxl" target="_blank">membre XXL</a> pour&nbsp;',
  you_must_be_xxl: 'Vous devez être membre XXL pour utiliser cette fonction.',
  xxl_feature: 'utiliser cette fonction',
  xxl_fullscreen: 'ouvrir les webcams en plein écran',
  xxl_pm: 'envoyer des messages privés',
  xxl_exclude: 'demander une exclusion',
  xxl_block: 'bloquer un utilisateur',
  xxl_follow: 'suivre un utilisateur',
  xxl_create_room: 'créer une salle',
  xxl_attach_photo: 'poster une photo sur le tchat',
  close: 'Fermer',
  cancel: 'Annuler',
  logged_out: 'Vous venez d’être déconnecté. Veuillez vous connecter de nouveau.',
  relogin: 'connecter',
  please_login: 'Vous devez vous connecter pour utiliser cette fonction.',
  you_have_reached_visitors_limit: 'Vous avez atteint votre temps limite de connexion anonyme. Veuillez vous connecter ou vous enregistrer pour continuer.',
  login: 'connexion',
  activation: 'Activation',
  nick: 'Pseudo',
  email: 'Email',
  nick_or_email: 'Pseudo ou Email',
  guest: 'Anonyme',
  code: 'Code',
  receive_password: 'Recevoir le mot de passe',
  closed_room: 'Salle codée',
  please_provide_password_for_room: function please_provide_password_for_room(room) {
    return 'Renseignez le mot de passe pour vous connecter sur la salle <span class="room-name">' + (0, _utils.escape)(room) + '</span>.';
  },
  password: 'Mot de passe',
  wrong_password: 'Ce mot de passe est faux.',
  forgot_password: 'Mot de passe oublié?',
  password_confirm: 'Confirmer le mot de passe',
  enter: 'Entrer',
  close_room_confirm: function close_room_confirm(room) {
    return 'Voulez vous fermer la salle <span class="room-name" title="' + (0, _utils.escape)(room) + '">' + (0, _utils.escape)(room) + '</span>?';
  },
  room_closed_message: function room_closed_message(room) {
    return 'La salle <span class="room-name">' + (0, _utils.escape)(room) + '</span> est fermée.';
  },
  personal_room_closed_message: function personal_room_closed_message(room) {
    return 'Cette salle <strong>My BobTV</strong> est fermée.';
  },
  enter_main_room: 'Aller sur la salle principale',
  room_info_created_by: 'Créée par',
  room_info_there_is: 'Il y a',
  DHM: ["j", "h", "mn"],
  exclude_user: 'Exclure l\'utilisateur',
  exclude_confirm: function exclude_confirm(user) {
    return "Vous allez demander l'exclusion de ".concat(user.nick, ".");
  },
  exclude_placeholder: 'Détails pour Bob (avec si possible un copier/coller)',
  exclude_placeholder_other: 'Autre raison',
  exclude_reason: 'Pourquoi voulez-vous exclure cet utilisateur?',
  exclude_information: ['Cette salle est modérée collectivement par tous les XXL.', 'Vous pouvez exclure un utilisateur qui ne respecte pas les CGU en utilisant le formulaire ci-dessus.', 'Le système compile vos demandes d\'exclusion et bloquera rapidement l\'utilisateur pour une durée de 24 heures ou plus.', 'Il est essentiel que tous les XXL participent à la modération collective afin de garantir une bonne ambiance dans le respect des CGU.'],
  block_user_excluded: function block_user_excluded(user) {
    var user_nick = (0, _utils.escape)(user.nick);
    if (user.gender == 1) return user_nick + " est exclu pour non respect des CGU.";
    if (user.gender == 2) return user_nick + " est exclue pour non respect des CGU.";
    if (user.gender == 3) return user_nick + " est exclu pour non respect des CGU.";
    return user_nick + " est exclu(e) pour non respect des CGU.";
  },
  block_user_excluded_personal: function block_user_excluded_personal(user) {
    var user_nick = (0, _utils.escape)(user.nick);
    if (user.gender == 1) return user_nick + " est exclu de cette salle My BobTV.";
    if (user.gender == 2) return user_nick + " est exclue de cette salle My BobTV.";
    if (user.gender == 3) return user_nick + " est exclu de cette salle My BobTV.";
    return user_nick + " est exclu(e) de cette salle My BobTV.";
  },
  site_interface_generic_error: 'Désolé, une erreur est survenue. Veuillez essayer de nouveau plus tard.',
  post_payment_text: "<strong>Félicitations!</strong><br/>Vous êtes à présent membre XXL et vous pouvez utiliser toutes les fonctions du site.<br/>Bon tchat et amusez-vous bien!",
  too_many_users_popup: function too_many_users_popup(chatroomName) {
    return "La salle " + (0, _utils.escape)(chatroomName) + " est pleine, seuls les membres XXL peuvent entrer.";
  },
  become_xxl: "Devenir XXL",
  excluded_blocked_popup: function excluded_blocked_popup(_ref) {
    var date = _ref.date,
      reason = _ref.reason;
    return "Votre accès aux salles BobTV est bloqué jusqu'au&nbsp;<em>" + date + "</em>." + (reason ? "<br/><br/><strong>Raison de votre blocage :</strong><br/><pre>" + reason + "</pre>" : "");
  },
  excluded_room_popup: function excluded_room_popup(_ref2) {
    var date = _ref2.date,
      room = _ref2.room,
      reason = _ref2.reason;
    return "Vous êtes exclus de la salle <strong>" + (0, _utils.escape)(room.name) + "</strong> jusqu'au&nbsp;<em>" + date + "</em>." + (reason ? "<br/><br/><strong>Raison de votre exclusion :</strong><br/><pre>" + reason + "</pre>" : "");
  },
  blacklisted_popup: function blacklisted_popup(_ref3) {
    var nick = _ref3.nick;
    return '<strong>' + (0, _utils.escape)(nick) + '</strong>  vous a bloqué, vous ne pouvez pas entrer dans sa salle My BobTV.';
  },
  get invalid_gender_for_gays_room() {
    var self = this;
    return function (_ref4) {
      var gender = _ref4.gender;
      return 'Désolé, cette salle est strictement réservée aux hommes. Votre genre est <strong>&quot;' + self.gender_to_str(gender) + '&quot;</strong>, vous ne pouvez pas entrer.';
    };
  },
  insufficient_funds: 'Insufficient funds',
  nonexistent_room_popup: "Désolé, cette salle My BobTV n’existe pas",
  not_enough_jetons_popup_title: 'Votre crédit de jetons',
  not_enough_jetons_popup_message: "Vous n'avez pas assez de jetons dans votre porte monnaie virtuel",
  not_enough_jetons_popup_button: 'Créditer',
  has_opened_mybobtv_room: 'a ouvert une salle My BobTV',
  has_started_mybobtv_showroom: 'fait un show sur My BobTV',
  showroom_welcome: function showroom_welcome(nick) {
    return nick + ' vous accueille dans sa salle My | Show.';
  },
  showroom_price: function showroom_price(price) {
    return 'Votre compte sera débité de ' + price + ' ' + plural(price, 'jeton', 'jetons') + ' par minute.';
  },
  replenish_your_wallet: 'Créditez votre compte',
  your_tokens_amount: function your_tokens_amount(amount) {
    return 'Votre crédit est de ' + amount + ' ' + plural(amount, 'jeton', 'jetons') + '.';
  },
  join_this_room: 'allez-y',
  join_show: 'Entrer',
  edit_my_room: "Éditer ma salle",
  showroom_price_input: 'Nombre de jetons collectés par minute auprès de chaque utilisateur',
  activate_showroom: 'Activer MY | Show',
  showroom_price_buttons_tooltip: 'Nombre de jetons collectés par minute auprès de chaque utilisateur',
  base_lib_not_loaded: 'La connexion avec la salle ne peut aboutir. Ce serveur est peut-être hors ligne ou alors votre connexion rencontre&nbsp;un&nbsp;problème.<br/><br/>Attendez un instant, essayez de rafraichir la page ou connectez-vous sur une&nbsp;autre&nbsp;salle.<br/><br/>Si le problème persiste, <a href="/contact" target="_blank">contactez Bob<a/>',
  register: "S'enregistrer",
  anonymous_login: 'Connexion sans compte',
  specify_a_nick: 'Choisissez un pseudo',
  anonymous_login_error_generic: 'Désolé vous ne pouvez pas entrer dans cette salle, essayez plus tard.',
  anonymous_login_error_user_exists: 'Ce pseudo existe déjà, veuillez en choisir un autre.',
  anonymous_login_error_invalid_characters: 'Votre pseudo doit être constitué de lettres ou de chiffres uniquement.',
  // settings window
  settings: 'Paramètres',
  camera: 'Webcam',
  microphone: 'Microphone',
  voice_processing: 'Voice processing',
  audio_filter: 'Filtre audio',
  voice: 'Conversation (micro)',
  music: 'Musique (carte son)',
  apply: 'Appliquer',
  save_settings: 'Enregistrer les paramètres',
  quality: 'Qualité de votre vidéo',
  quality_description: 'Ajustez la qualité de votre vidéo en fonction de votre connexion et des performances de votre ordinateur. Une valeur élevée peut ralentir le tchat.',
  quality__240p: '240p - Faible (320x240)',
  quality__360p: '360p - Moyenne (480x360)',
  quality__480p: '480p - Standard (640x480)',
  quality__720p: '720p - Haute (960x720)',
  quality__720hd: '720p HD - Haute Définition (1280x720)',
  click: 'Cliquez',
  allow: 'Autoriser',
  camera_access_right_notheme: function camera_access_right_notheme(statusMiddle) {
    return statusMiddle ? 'Cliquez sur' : 'ou cliquez sur';
  },
  camera_access_right_theme: 'pour utiliser votre webcam et votre micro.',
  tab_general: 'Général',
  tab_media: 'Média',
  tab_sound: 'Sons',
  your_mood: 'Votre humeur',
  pm_request: "Demande de message privé",
  pm_message: "Nouveau message privé",
  new_tip: "Nouveaux jetons reçus",
  mood: 'Humeur',
  show_your_mood: "Afficher l'humeur",
  offline: 'déconnecté',
  right_point_info: "Les jetons acquis permettent d'offrir des cadeaux virtuels et d'effectuer des achats sur la boutique Bobstore. <a href=\"/membre/wallet/replenish\" target=\"_blank\">Cr\xE9diter</a>",
  cgu_roll_up: 'Lire moins...',
  cgu_read_more: 'Lire plus...',
  cgu_title: 'Bienvenue sur BobTV!',
  cgu_desc: 'Prenez le temps de lire les Conditions Générales d’Utilisation avant de participer au tchat. Le non respect des CGU entraînera votre expulsion du site.',
  cgu_head_1: "Conditions Générales d'Utilisation (CGU)",
  cgu_text_1: "<li>Vous devez \xEAtre majeur pour acc\xE9der \xE0 ce site.</li>\n                <li>Aucune participation au Tchat en pr\xE9sence d'enfants et aucun dialogue concernant des enfants.</li>\n                <li>Restez courtois et respectueux envers les autres utilisateurs. Aucune vulgarit\xE9 ne sera tol\xE9r\xE9e.</li>\n                <li>Ne soyez pas directif avec les femmes et les couples, laissez leur l\u2019initiative.</li>\n                <li>Interdiction d'\xE9changer des adresses \xE9mail, Skype ou de sites Internet sur la salle. Les \xE9changes doivent se faire en messages priv\xE9s.</li>\n                <li>\xC9crivez en minuscules en respectant les r\xE8gles \xE9l\xE9mentaires de grammaire et d'orthographe.</li>\n                <li>Le flood est interdit (r\xE9p\xE9tition de mots sur plusieurs lignes)</li>\n                <li>En aucun cas un homme seul ne peut utiliser le logo \"Femme\" sur son profil (sauf les travestis).</li>\n                <li>Aucune consultation du tchat lorsque vous conduisez un v\xE9hicule.</li>",
  cgu_head_2: "BobTV c'est quoi?",
  cgu_text_2: "<li>BobTV est un site d\u2019exhibition r\xE9serv\xE9 aux adultes. La nudit\xE9 et les pratiques sexuelles sont tol\xE9r\xE9es dans la seule limite des bonnes m\u0153urs et de la l\xE9gislation.</li>\n                <li>Vous \xEAtes libre :\n                    <div>- de vous afficher en cam ou non,</div>\n                    <div>- d\u2019\xEAtre nu(e) ou non.</div>\n                </li>\n                <li>BobTV est un site de partage. Vos \xE9changes doivent rester conviviaux et respectueux.\n                    Les insultes, critiques, pol\xE9miques ou moqueries et ne sont pas tol\xE9r\xE9es. Partagez des\n                    moments de plaisir, de d\xE9tente et d\u2019humour mais en aucun cas votre vie priv\xE9e. Laissez\n                    vos convictions, votre famille, vos soucis et vos malheurs en dehors du site.</li>\n                <li>BobTV est un site communautaire. Exprimez-vous et diffusez librement, sans monopoliser\n                    le tchat, vous devez le partager. R\xE9digez correctement des phrases compl\xE8tes, sans\n                    langage SMS. Les bouts de phrases post\xE9s sur plusieurs lignes sont assimil\xE9s \xE0 du spam.\n                    Une police d\u2019\xE9criture de couleur vive ou de grande taille est agressive, restez discret.</li>",
  cgu_head_3: "Comment ça marche?",
  cgu_text_3: "<li>Cliquez sur les pseudos dans la liste des connect\xE9s pour ouvrir leur webcam.</li>\n                <li>S\xE9lectionnez vos sources audio et vid\xE9o dans les param\xE8tres de votre navigateur, en cliquant sur la petite ic\xF4ne \"cam\xE9ra\" situ\xE9e dans la barre sup\xE9rieur de votre navigateur.</li>\n                <li>R\xE9glez le % du Zoom de la page dans les param\xE8tres de votre navigateur ou par la touche Ctrl et molette de votre souris / touche Ctrl et touches + ou - de votre clavier.</li>\n                <li>Pour diffuser votre audio, cliquez sur le bouton \"micro\" situ\xE9 dans la fen\xEAtre de votre webcam.</li>\n                <li>Les utilisateurs ayant une ic\xF4ne \"haut parleur\" devant leur pseudo sont ceux qui diffusent leur audio. Ouvrez la fen\xEAtre de leur webcam et cliquez sur l\u2019ic\xF4ne \"haut parleur\" pour les \xE9couter.</li>\n                <li>Gardez la barre de d\xE9filement en position basse pour voir le texte d\xE9filer automatiquement.</li>\n                <li>Un menu de fonctions est accessible par un clic droit sur les pseudos dans la liste des connect\xE9s et sur le tchat.</li>\n                <li>Triez la liste des connect\xE9s \xE0 partir du menu signal\xE9 par 3 points oranges verticaux au dessus de la liste des connect\xE9s.</li>\n                <li>4 tailles de webcams sont disponibles \xE0 partir de la fen\xEAtre des webcams : petite (par d\xE9faut), moyenne, grande et plein \xE9cran (r\xE9serv\xE9 aux membres XXL).</li>\n                <li>Cachez votre webcam \xE0 partir du bouton \"cam\xE9ra\" situ\xE9 \xE0 gauche du formulaire d'entr\xE9e de texte. Votre webcam sera malgr\xE9 tout visible par tous.</li>\n                <li>En mode gratuit vous pouvez regarder une webcam \xE0 la fois 60 minutes par tranche de 24 heures sur chacune des salles.</li>\n                <li>Les membres XXL ont leur pseudo en caract\xE8res gras dans la liste des connect\xE9s.</li>",
  cgu_head_4: "Principes de la modération collective",
  cgu_text_4: "<li>Les membres XXL sont en charge de mod\xE9rer les salles et de faire respecter les CGU.</li>\n                <li>La mod\xE9ration se fait sur le principe d'une demande collective d'exclusion (lien \"Exclure\" dans le menu du clic droit sur la liste des connect\xE9s).</li>\n                <li>Tout utilisateur ne respectant pas les CGU sera d\xE9connect\xE9 de la salle et interdit d'acc\xE8s 24 heures ou plus.</li>",
  cgu_good_chat: 'Les salles sont compatibles avec:',
  receive_password_text: 'Entrez votre adresse email ou pseudo pour recevoir immédiatement votre mot de passe.',
  congratulations: 'Félicitation!',
  registration_back: 'Retour',
  enter_sms_activation_code: 'Entrez le code d’activation que vous avez reçu par SMS.',
  enter_activation_code_text: function enter_activation_code_text(email) {
    return "Entrez le code d'activation que vous avez re\xE7u par \xE9mail \xE0 votre adresse <span class=\"underline\">".concat(email, "</span> ou cliquez sur le lien d'activation contenu dans cet \xE9mail.");
  },
  enter_activation_code_text_min: 'Si vous ne recevez pas cet émail immédiatement, consultez le dossier "spam" de votre messagerie et marquez ce message comme "non-spam". Si vous ne trouvez pas cet émail, <a href="#" id="send-sms">demandez un SMS</a> pour recevoir le code d’activation.',
  receive_sms_with_code: 'Recevez un SMS avec le code d’activation.',
  enter_phone_to_receive_sms: 'Entrez votre numéro de téléphone portable pour recevoir un code d’activation par SMS.',
  enter_as_anonymous: 'Entrer sans compte',
  multi_rooms_join: 'Rejoindre',
  multi_rooms_join_full: 'Rejoindre en multi-salles',
  multi_rooms_quit: 'Quitter',
  multi_rooms_quit_full: 'Quitter le multi-salles',
  notifications: 'notifications',
  tip: function tip(amount) {
    return "vous a offert ".concat(amount, " ").concat(amount === '1' ? 'jeton!' : 'jetons!');
  },
  tip_private: function tip_private(sender, amount) {
    var nick = (0, _utils.escape)(sender);
    if (parseInt(amount) === 1) return "".concat(nick, " vous a offert 1 jeton!");else return "".concat(nick, " vous a offert ").concat(amount, " jetons!");
  },
  tip_sent: 'Vous avez offert %1 jetons à',
  tip_private_sent: function tip_private_sent(recpient, amount) {
    var nick = (0, _utils.escape)(recpient);
    if (parseInt(amount) === 1) return "Vous avez offert 1 jeton \xE0 ".concat(nick, ".");else return "Vous avez offert ".concat(amount, " jetons \xE0 ").concat(nick, ".");
  },
  gift: 'vous a offert un cadeau virtuel!',
  new_follower: 'vient de s\'abonner à votre compte.',
  guestbook_message: 'a rédigé un message sur votre livre d\'or.',
  message: 'vous a envoyé un nouveau message.',
  membership_gift: 'vous a offert un abonnement XXL de %1 jours!',
  membership_gift_public: 'a offert un abonnement XXL à',
  followed_user_is_online: 'vient de se connecter sur',
  user_membership_expired: 'Votre XXL a expiré le %1. Renouvelez-le maintenant!',
  user_membership_almost_expired: 'Votre XXL va expirer le %1. Renouvelez-le dès maintenant!',
  error: "Vous semblez rencontrer un problème",
  submit_error: "Soumettez un rapport de crash",
  submit_success: "Votre commentaire est envoyé, veuillez rafraîchir la page (F5 | ⌘+R)",
  just_reload: "...ou simplement",
  reload_link: "rafraîchissez la page",
  empty_notifications: "Vous n'avez pas de notification.",
  addToHomescreen: "Ajouter BobTV à l'écran d'accueil",
  removeApp: "Pour supprimer/réinstaller bobTV sur votre l'écran d'accueil, copiez/collez l'URL suivante dans votre barre d'adresse:",
  muteCountdown: function muteCountdown(minutes) {
    return "Suite \xE0 votre non respect des CGU vous ne pouvez plus \xE9crire pendant ".concat(minutes, " minutes.");
  },
  muted_notification: 'est censuré(e) une heure pour non respect des CGU.',
  unmuted_notification: 'est décensuré(e).',
  recordMessage: 'Votre clip vidéo sera publié sur le Mur dans quelques minutes.',
  streamRecordError: 'Un problème est survenu lors de l\'enregistrement de votre clip vidéo.',
  XXLBannerText: 'Vous devez être membre XXL pour regarder la vidéo en entier.',
  XXLBannerButton: 'Devenez membre XXL',
  confirmRecordText: "Enregistrez un clip vidéo de 60 secondes qui sera aussitôt publié sur \"Le Mur\". Vous pouvez interrompre l'enregistrement à partir de 10 secondes.",
  confirmPhotoText: "Enregistrez une photo qui sera aussitôt publié sur \"Le Mur\".",
  confirm: "Confirmer"
};
exports["default"] = _default;